module.exports = __webpack_public_path__ + "static/media/image_10.2bf749be.png";